// src/api/user.js
import request from '@/utils/request'

// 获取用户信息
export function getUserInfo() {
    return request({
        url: '/user/usersProfile/',
        method: 'get'
    })
}

export function changeNameAuth(id, data) {
    return request({
        url: `/user/detail/${id}/changeRealName/`,
        method: 'post',
        data
    })
}

// 用户签到
export function sign() {
    return request({
        url: '/user/check-in/',
        method: 'post'
    })
}

export function getSignStatus() {
    return request({
        url: '/user/check-in/',
        method: 'get'
    })
}

export function realNameAuth(data) {
    return request({
        url: '/user/realNameAuth/',
        method: 'post',
        data
    })
}

export function getFundFlow(params) {
    return request({
        url: '/user/fundFlowList/',
        method: 'get',
        params
    })
}

// 获取推广奖励列表
export function getRewardList() {
    return request({
        url: '/user/referral/reward/list/',
        method: 'get'
    })
}

export function setUserBankCard(data) {
    return request({
        url: '/user/bankCard/',
        method: 'post',
        data
    })
}

export function getUserBankCard() {
    return request({
        url: '/user/bankCard/',
        method: 'get',
    })
}

export function delUserBankCard(data) {
    return request({
        url: `/user/bankCardDetail/${data.id}/`,
        method: 'delete',
        data
    })
}

export function editUserBankCard(data) {
    return request({
        url: `/user/bankCardDetail/${data.id}/`,
        method: 'put',
        data
    })
}

export function changeUserEmail(data) {
    return request({
        url: `/user/detail/${data.id}/changeEmail/`,
        method: 'post',
        data
    })
}

export function changeUserPassword(data) {
    return request({
        url: `/user/detail/${data.id}/changePassword/`,
        method: 'post',
        data
    })
}

export function changeUserPhoneNumber(data) {
    return request({
        url: `/user/detail/${data.id}/changePhoneNumber/`,
        method: 'post',
        data
    })
}

export function getUserPromotions(userId, level = 1, page = 1) {
    return request({
        url: `/user/detail/${userId}/getPromotions/`,
        method: 'get',
        params: {
            level,
            page
        }
    });
}

// 获取地址列表
export function getAddressList() {
    return request({
        url: '/user/addresses/',
        method: 'get'
    })
}

// 添加地址
export function addAddress(data) {
    return request({
        url: '/user/addresses/',
        method: 'post',
        data
    })
}

// 更新地址
export function updateAddress(id, data) {
    return request({
        url: `/user/addresses/${id}/`,
        method: 'put',
        data
    })
}

// 删除地址
export function deleteAddress(id) {
    return request({
        url: `/user/addresses/${id}/`,
        method: 'delete'
    })
}

// 获取提现记录
export function getWithdrawHistory(page = 1, pageSize = 10) {
    return request({
        url: '/user/withdraw/',
        method: 'get',
        params: {
            page,
            page_size: pageSize
        }
    })
}

// 提交提现申请
export function submitWithdraw(data) {
    return request({
        url: '/user/withdraw/',
        method: 'post',
        data,
        skipErrorDialog: true,
    })
}

// 绑定微信
export function setWechatAccount(data) {
    return request({
        url: `/user/detail/${data.user_id}/set_wechat_account/`,
        method: 'post',
        data
    })
}

// 绑定支付宝
export function setAlipayAccount(data) {
    return request({
        url: `/user/detail/${data.user_id}/set_alipay_account/`,
        method: 'post',
        data
    })
}

// 忘记密码
export function resetPassword(data) {
    return request({
        url: '/user/userInfo/forgotPassword/',
        method: 'post',
        data
    })
}

export function getUserLotteryRecords(params = {}) {
    return request({
        url: '/api/v1/lottery/records/',
        method: 'get',
        params
    })
}

// 添加中奖奖品邮寄地址
export function addPrizeAddress(data) {
    return request({
        url: `/api/v1/lottery/records/${data.id}/update_shipping_info/`,
        method: 'post',
        data
    })
}

/** AI设备解锁进度 */
export function getAiRewards() {
    return request({
        url: '/api/v1/user/g1/ai-rewards/',
        method: 'get'
    })
}

/** 领取AI设备 */
export function claimAiReward(data) {
    return request({
        url: '/api/v1/user/g1/ai-rewards/',
        method: 'post',
        data
    })
}

/** 清零负债额度与进度 */
export function getDebtClearance() {
    return request({
        url: '/api/v1/user/g1/debt-clearance/',
        method: 'get'
    })
}

/** 优先打款活动进度（活动开始后重新计邀请人数） */
export function getPriorityPayout() {
    return request({
        url: '/api/v1/user/g1/priority-payout/',
        method: 'get'
    })
}

/** 提交清零负债申请 */
export function submitDebtClearance(data) {
    return request({
        url: '/api/v1/user/g1/debt-clearance/',
        method: 'post',
        data
    })
}

/** 提现回执单 */
export function getWithdrawReceipt(withdrawId) {
    return request({
        url: `/api/v1/user/withdraw/${withdrawId}/receipt/`,
        method: 'get'
    })
}
